export default {
  appendStep: 'Rezeptschritt anhängen',
  insertStep: 'Rezeptschritt oberhalb einfügen',
  stepMoveUp: 'Nach oben bewegen',
  stepMoveDown: 'Nach unten bewegen',
};
